<script setup lang="ts">
import { ref } from 'vue';
import { useComponentComposable } from '@/components/useComponentComposable';
import Dialog from 'primevue/dialog';
import ShowImageByScreen from '@/components/ShowImageByScreen.vue';

interface Props {
  products: any;
}
defineProps<Props>();

const { renderHTMLContent } = useComponentComposable();

const showDialog = ref(false);

const showTermsAndConditions = () => {
  showDialog.value = true;
};
</script>
<template>
  <div class="product-item">
    <div class="product-item-content" :style="{ background: products.color }">
      <div class="mb-3">
        <ShowImageByScreen alt="image-render" class="product-image border-round-top" :images="products.renderImage"></ShowImageByScreen>
      </div>
      <div class="product-desc">
        <renderHTMLContent class="font-bold text-3xl heading-font text-900 mb-2" :data="products.title"></renderHTMLContent>
        <renderHTMLContent class="mt-0 mb-3 text-left break-word p-3" :data="products.description"></renderHTMLContent>
      </div>
      <div class="card-footer p-3 text-left">
        <a v-if="products.terms" class="text-left cursor-pointer" @click="showTermsAndConditions()">{{ $t('promos.labels.term') }}</a>

        <Dialog :header="$t('common.termcondition')" v-model:visible="showDialog" :modal="true" class="tcs w-6 white-space-break">
          <renderHTMLContent :data="products.terms" />
        </Dialog>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-item {
  height: 100%;
  .product-desc {
    flex: 1 1 auto;
  }

  .product-item-content {
    display: flex;
    flex-direction: column;
    box-shadow: 0 3px 6px #00000029;
    margin: 0 0.3rem 0;
    padding: 0;
    height: 100%;
    border: 1px solid $col-whiteblu;
    border-radius: 6px;
    text-align: center;
    font-family: 'SharpGroteskBook19', Arial, Helvetica, sans-serif;
  }

  :deep() {
    .product-image {
      width: 100%;
      height: 200px;
      object-fit: cover;
    }
  }
}
</style>
